import script from "./BioIntelligentPart2.vue?vue&type=script&setup=true&lang=js"
export * from "./BioIntelligentPart2.vue?vue&type=script&setup=true&lang=js"

import "./BioIntelligentPart2.vue?vue&type=style&index=0&id=baff958e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baff958e"]])

export default __exports__